import Box from "@mui/material/Box";
import { AddButton } from "app/components/Button/AddButton";
import BreadCrumb from "app/components/BreadCrumb";
import { ScrollableView } from "app/components/ScrollableView";
import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useInjectReducer, useInjectSaga } from "utils/redux-injectors";

import AddRoofMaterialModal from "./components/AddRoofMaterialModal";
import RoofMaterialTypeTable from "./components/RoofMaterialTable";
import {
  selectRoofMaterialTypeList,
  selectRoofMaterialTypeLoading,
  selectRoofMaterialTypeMeta,
} from "./redux/selector";
import roofMaterialTypeSaga from "./redux/saga";
import { roofMaterialTypeActions, reducer, sliceKey } from "./redux/slice";
import { useStyles } from "./styles";

const RoofMaterialType = () => {
  const { t, i18n } = useTranslation();
  const styles = useStyles();
  const dispatch = useDispatch();

  useInjectReducer({
    key: sliceKey,
    reducer,
  });

  useInjectSaga({
    key: sliceKey,
    saga: roofMaterialTypeSaga,
  });

  const rows = useSelector(selectRoofMaterialTypeList);
  const loading = useSelector(selectRoofMaterialTypeLoading);
  const meta = useSelector(selectRoofMaterialTypeMeta);

  useEffect(() => {
    dispatch(roofMaterialTypeActions.getRoofMaterialTypeList());
  }, [dispatch]);

  const hasMoreItems = meta.currentPage < meta.totalPages;

  const getNextPage = () => {
    if (!loading && hasMoreItems) {
      dispatch(roofMaterialTypeActions.getNextPageItems());
    }
  };

  return (
    <Box className={styles.container}>
      <Box className={styles.scrollContent} dir={i18n.dir()}>
        <Box className={styles.pageContent}>
          <BreadCrumb
            title={t("SIDEBAR.ROOF_MATERIAL_TYPE")}
            iconPosition="end"
          />
          <Box dir="ltr">
            <AddButton
              label={t("ROOF_MATERIAL_TYPE.ACTIONS.ADD")}
              onClick={() => dispatch(roofMaterialTypeActions.openAddModal())}
            />
          </Box>
          <Box className={styles.tableContainer}>
            <ScrollableView
              borderless
              height="calc(100vh - 200px)"
              loadMore={getNextPage}
              hasMoreItems={hasMoreItems}
            >
              <RoofMaterialTypeTable rows={rows} loading={loading} />
            </ScrollableView>
          </Box>
        </Box>
      </Box>
      <AddRoofMaterialModal />
    </Box>
  );
};

export default RoofMaterialType;
